import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './21-explain-gan.mp3';
import ganDiagram from './21-explain-gan.png';

const transcript = `
  Goed, ik houd het simpel...

  Het begon met automatisch labelen van afbeeldingen. AI kreeg afbeeldingen te zien en moest leren herkennen wat erop 
  stond, bijvoorbeeld "kat" of "hond." Dit werkte doordat de AI patronen leerde in gelabelde datasets. Maar om dat 
  goed te doen, moesten mensen eerst duizenden afbeeldingen handmatig labelen. Dat was tijdrovend.

  Toen bedacht iemand iets briljants: wat als we het probleem omdraaien? In plaats van dat de AI leert om afbeeldingen 
  te labelen, laten we de AI zélf afbeeldingen genereren. Als de AI een overtuigende afbeelding van een kat kan maken, 
  betekent dat dat hij begrijpt hoe een kat eruitziet. 

  Dit idee leidde tot Generative Adversarial Networks, of GANs. Het werkt zo: er zijn twee AI's. De Generator probeert 
  een afbeelding te maken, zoals een kat. De Discriminator beoordeelt het resultaat en zegt of het echt lijkt of niet. 
  Als de Discriminator "nep" zegt, leert de Generator wat hij moet verbeteren. Ze blijven elkaar uitdagen, net zo lang 
  tot de Generator beelden maakt die zelfs de Discriminator niet meer als nep kan herkennen.

  Dit idee werd bedacht door Ian Goodfellow in 2014 en was een enorme doorbraak. Dankzij GANs kunnen we nu beelden 
  maken die nooit eerder hebben bestaan. Dat vormt de basis voor technieken zoals synthografie. Fascinerend, toch?
`;

// Jonathan: Ja maar wel een beetje technisch. Maar dit gebruiken we nu niet meer voor synthografie toch?

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="bottom-right" networkBackground="full">
      <div className="flex flex-col items-center justify-center h-full">
        <WebContent
          animation={{
            type: 'fade',
            delay: 0,
            duration: 800,
          }}
        >
          <h2 className="text-5xl mb-12">Generative Adversarial Networks</h2>
        </WebContent>
        <WebContent
          animation={{
            type: 'fade',
            delay: 3000,
            duration: 1000,
          }}
        >
          <div className="w-[1000px]">
            <img
              src={ganDiagram}
              alt="GAN Diagram showing Generator and Discriminator"
              className="w-full"
            />
          </div>
        </WebContent>
      </div>
    </Slide>
  );
};
